import { Carousel as AntdCarousel } from "antd";
import { ChevronLeftIcon, ChevronRightIcon } from "@/base/static/icons";
import { CMP_PREFIX } from "@/base/constant";
import type { GetProps } from "antd";

export type CarouselProps = Partial<GetProps<typeof AntdCarousel>>;

export const carouselPrefixCls = `${CMP_PREFIX}-carousel`;

export const Carousel = ({ ...props }: CarouselProps) => {
  return (
    <AntdCarousel
      nextArrow={<ChevronRightIcon />}
      prevArrow={<ChevronLeftIcon />}
      {...props}
    />
  );
};
